import { useEffect, useState } from "react";

import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useMutation, useQuery } from "react-query";

import {
  showAttachmentsEmployes,
  updateAttachmentsEmployes,
} from "../../../../../MyApi/sb/employes";

import PageHeader from "../../../../../Components/UI/PageHeader";
import EditEmployeAttachments from "../../../../../Components/sb/employ/employUpdate/editEmployeAttachments";
import LoadingSpinner from "../../../../../Components/UI/spinner";

const EmployeAttachmentupdate = () => {
  const [name, setName] = useState("");
  const [type, setType] = useState("");
  const [expired_at, setExpiredAt] = useState("");
  const { id } = useParams();

  const { data, isLoading } = useQuery(["showAttachments", id], () =>
    showAttachmentsEmployes(id)
  );

  const attachments = data?.data || [];


  useEffect(() => {
    setName(attachments.name);
    setType(attachments.type);
    setExpiredAt(attachments.expired_at);
  }, [attachments]);
  const mutation = useMutation(
    ["updateEmployeAttachments", id],
    (postData) => updateAttachmentsEmployes(postData, id),
    {
      onSuccess: (data) => {
        toast.success(`${data.message}`);
      },
      onError: (error) => {
        toast.error(`${error.response.data.message}`);
      },
    }
  );

  const handlePostRequest = () => {
    const formData = new FormData();
    formData.append("name", name);
    formData.append("type", type);
    formData.append("sb_employe_id", id);
    formData.append("expired_at", expired_at);
    mutation.mutate(formData);
  };

  const isDisabled = () => {
    return;
  };
  if (isLoading) {
    return <LoadingSpinner />;
  }
  return (
    <div>
      <PageHeader
        title="تعديل ملحقات الموظفين"
        showBack
        saveButton
        handlePostRequest={handlePostRequest}
        isdisbled={isDisabled}
      />
      <EditEmployeAttachments
        setName={setName}
        name={name}
        type={type}
        expired_at={expired_at}
        setExpiredAt={setExpiredAt}
      />
    </div>
  );
};

export default EmployeAttachmentupdate;
